<template>
  <section id="investor" class="investor-area">
    <div class="container container-sm">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2>Are you an investor in Ghana's Green Economy?</h2>
          <p>
            Fill in
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLScWOL9hidjf61SGfV-L-zJslbUXpM0D4OmQXeKbe4MHaOwMGQ/viewform"
              >this form</a
            >
            to be included in the database! Looking for the top <br />Green
            Economy startups in Ghana? View the companies in GCIC's cohorts
            <a href="http://www.ghanacic.org/our-clients/">here</a>.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "InvestorFormBanner"
};
</script>



// WEBPACK FOOTER //
// src/elements/InvestorFormBanner.vue